import React, {useState} from 'react';

export const CambiarContraseña = (props) => {
	const {cambioContraseña, confirmacionContraseña} = props;

	const [contrasenas, setContrasenas] = useState({
		contrasena: '',
		confirmarContrasena: '',
	});

	const onInputChange = (e) => {
		const {name, value} = e.target;
		setContrasenas({...contrasenas, [name]: value});
	};

	return (
		<div className='ContentOlvContraseña'>
			<div className='centrador'>Introduzca la nueva contraseña</div>
			<div className='inputCorreoOlvidarContraseña'>
				{!confirmacionContraseña && (
					<div className='centrador correroInvalido'>Las constraseña no coinciden</div>
				)}
				<input
					type='password'
					placeholder='Nueva contraseña'
					className='usernameFormularioLoginStandar inputFormularioLoginStandar inputTextUsuario'
					value={contrasenas.contrasena}
					name='contrasena'
					onChange={onInputChange}
				/>
			</div>
			<div className='inputCorreoOlvidarContraseña'>
				<input
					type='password'
					placeholder='Repita la contraseña'
					className='usernameFormularioLoginStandar inputFormularioLoginStandar inputTextUsuario'
					value={contrasenas.confirmarContrasena}
					name='confirmarContrasena'
					onChange={onInputChange}
				/>
			</div>
			<div className='centrador'>
				<div
					className='button'
					onClick={() => cambioContraseña(contrasenas)}
				>
					<b>Cambiar contraseña</b>
				</div>
			</div>
		</div>
	);
};
